import { gql } from "@apollo/client";

export const getModuleLicenses = gql`
    query getModuleLicenses {
        module_license {
            module_license_id
            name
        }
    }
`;
